import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  production: false,
  apiKey: '34c36c85-48c6-45ac-a61f-e2b129bb279f',
  apiBaseUrl: 'https://staging.kingslizepizza.be/api',
  oneSignalAppId: '03628ae2-2d12-4e55-b3a7-e22733b134f7',
  mapboxKey: 'pk.eyJ1Ijoib3Vzc2llMDAiLCJhIjoiY2w0ZnU0MzZ2MDNsNjNqbThpZnNoemY2cSJ9.qGYBkueC58wXq3rbcJRsrA',
  sipCall: {
    realm: "kingslizepizza.allocloud.com:10060;transport=udp",
    branches: {
      1: {
        username: "kingslizepizza.oxxqhdoy",
        password: "MnMVEzJ1B2KVs1aTbKy",
      },
      2: {
        username: "kingslizepizza.f9vidg0p",
        password: "XzW8B2QUo5UnCEaROtC",
      },
      8: {
        username: "kingslizepizza.7kxtq6wl",
        password: "sl68iVJ2K5tLW46rIa6",
      },
      6: {
        username: "kingslizepizza.t5vb2imb",
        password: "BKZqhSbmAgRYeuv8npd",
      },
      4: {
        username: "kingslizepizza.y0m3u53z",
        password: "tHDxLPG2S7U6BNN6U2I",
      },
    },
  },
  pusher: {
    appId: "1483958",
    key: "799a2e24b4b6b3ec38b8",
    secret: "8bdc8aeafd320eae80d3",
    cluster: "eu"
  },
  featureFlags: {
    chat: true,
  },
  vivaBranches: {
    1: {
      apiKey: 'uyecc44bo8gqhajdg8sduh6wrj8gs0e8tz6k0z8kzp631.apps.vivapayments.com',
      apiSecret: 'EA0eiz1nqRxb204AKWPvxqPx7OGYfM',
      sourceIdCode: '1228',
      pinCode: '039214'
    },
    6: {
      apiKey: '09ss0e9z2yu031g45pqini492eg74ljv12qgbp8mq4wt4.apps.vivapayments.com',
      apiSecret: '05YajP6J035F3sN7ySNWY3xh4GSDhE',
      sourceIdCode: '7323',
      pinCode: '834912'
    },
    8: {
      apiKey: '99t31q9t9a6b009bnnmae7ae2cbft2oekw2bcqxm9rab5.apps.vivapayments.com',
      apiSecret: 'e35A58jZC5z7v8ALLPwEw554F31SEN',
      sourceIdCode: '8907',
      pinCode: '834912'
    },
    2: {
      apiKey: '3047yxyfda7vyt4uejkm6qcoxmqrhnglvp4cowce8t7z2.apps.vivapayments.com',
      apiSecret: 'KSsLP7K4TfEu4BB3dt2W14duXtrkPX',
      sourceIdCode: '9253',
      pinCode: '434912'
    },
    4: {
      apiKey: 'mqvhgrm53hjwtkkaq2nj3udm3ly1dpkac7adw511ytgw4.apps.vivapayments.com',
      apiSecret: 'chvN1697HFetd2ne6nfEq1sJWbOntF',
      sourceIdCode: '6238',
      pinCode: '432588'
    }
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
